import { IonCol } from "@ionic/react";
import { useHistory } from "react-router";

interface Props {
  imageLink: string;
}

const BackGroundImg: React.FC<Props> = ({ imageLink }) => {
  const history = useHistory();
  return (
    <IonCol
      size-lg="9"
      size="9"
      size-sm="9"
      className="background-picture border-radius clickable"
      style={{
        backgroundImage: 'url("' + imageLink + '")',
        height: "auto",
        backgroundColor: "black",
        borderRadius: "0 20px 20px 0",
      }}
      onClick={() => history.push("/welcome")}
    ></IonCol>
  );
};

export default BackGroundImg;
